<template>
  <tooltip v-if="hasPermission(permission)" label="Edit" type="small" placement="top">
    <router-link :to="to" tag="button" class="button">
      <span class="icon">
        <i class="fa fa-pencil-square-o"></i>
      </span>
    </router-link>
  </tooltip>
</template>

<script>
  import mixin from 'components/mixin';

  export default {
    name: "edit-button",
    mixins: [mixin],
    props: {
      to: [Object, String],
      permission: Array
    }
  }
</script>

<style scoped>

</style>